import React, { Component, Fragment } from 'react'
import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import validation from '../../validation/validation';
import axios from 'axios'
import AppURL from '../../api/AppURL';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Contact extends Component {

     constructor() {
          super();
          this.state = {
               name: "",
               email: "",
               message: ""
          }
     }

     nameOnChange = (event) => {
          let name = event.target.value;
          // alert(name);
          this.setState({ name: name })
     }

     emailOnChange = (event) => {
          let email = event.target.value;
          // alert(email);
          this.setState({ email: email })
     }

     messageOnChange = (event) => {
          let message = event.target.value;
          // alert(message);
          this.setState({ message: message })
     }

     onFormSubmit = (event) => {

          let name = this.state.name;
          let email = this.state.email;
          let message = this.state.message;
          let sendBtn = document.getElementById('sendBtn');
          let contactForm = document.getElementById('contactForm');

          if (message.length == 0) {
               toast.error("Please write your message");
          }
          else if (name.length == 0) {
               toast.error("Please write down our name");
          }
          else if (email.length == 0) {
               toast.error("Please write down our Email");
          }

          //এই লাইনটি চেক করছে যে name ভেরিয়েবলটি নির্দিষ্ট নিয়মে মিলে কিনা। এখানে validation.NameRegx একটি নিয়ম (রেগুলার এক্সপ্রেশন বা regex) ধরে রাখা 
          //হয়েছে, যা name এর মান যাচাই করতে ব্যবহার করা হচ্ছে।
          //বিশদ ব্যাখ্যা

          //!(validation.NameRegx).test(name) লাইনটি মূলত validation.NameRegx এর .test() মেথড দিয়ে name চেক করছে।
          //.test(name) মেথডটি name এর মধ্যে রেগুলার এক্সপ্রেশনটি মিলে কিনা তা চেক করে এবং true বা false রিটার্ন করে।
          //যদি name এর মান রেগুলার এক্সপ্রেশনটির সাথে মিলে যায়, তাহলে .test() মেথডটি true রিটার্ন করবে।
          //যদি না মেলে, তাহলে .test() মেথডটি false রিটার্ন করবে।
          //! চিহ্নটি not বোঝায়। এটি true মানকে false এবং false মানকে true তে পরিণত করে।

          //তাহলে, (validation.NameRegx).test(name) যদি false হয়, অর্থাৎ name রেগুলার এক্সপ্রেশনটির সাথে মেলে না, তখন ! ব্যবহার করে সেটিকে true বানানো হয়, 
          //এবং toast.error("Invalid Name") কল করা হয়।
          //উদাহরণস্বরূপ

          //যদি validation.NameRegx শুধুমাত্র অক্ষরগুলোর জন্য একটি নিয়ম (regex) থাকে, তাহলে name এর মধ্যে সংখ্যা বা বিশেষ চিহ্ন থাকলে এটি false রিটার্ন করবে 
          //এবং Invalid Name ত্রুটি দেখাবে।

          else if (!(validation.NameRegx).test(name)) {
               toast.error("Invaid Name");
          }
          else {

               sendBtn.innerHTML = "Sending...";

               //এই কোডটি একটি FormData অবজেক্ট তৈরি করে এবং এতে তিনটি ফিল্ড (name, email, এবং message) যুক্ত করে।
               //FormData একটি বিশেষ JavaScript অবজেক্ট, যা সাধারণত ফর্ম ডেটা AJAX বা API-তে পাঠানোর জন্য ব্যবহৃত হয়। 
               //এটি মূলত কী-ভ্যালু পেয়ার হিসেবে ডেটা সংরক্ষণ করে এবং multipart/form-data ফরম্যাটে সার্ভারে ডেটা পাঠাতে সহায়ক।
               //এটি একটি নতুন FormData অবজেক্ট তৈরি করে এবং MyFormData নামে একটি ভেরিয়েবলে সংরক্ষণ করে।
               let MyFormData = new FormData();
               //append মেথডটি FormData অবজেক্টে একটি নতুন কী-ভ্যালু পেয়ার যোগ করে।
               //এখানে "name" কী হিসেবে সংরক্ষণ করা হয়েছে, এবং name ভেরিয়েবলের মানটি এর ভ্যালু হিসেবে যুক্ত করা হয়েছে।
               //বাকিগুলো একইভাবে
               MyFormData.append("name", name)
               MyFormData.append("email", email)
               MyFormData.append("message", message)

               axios.post(AppURL.PostContact, MyFormData).then(function (response) {
                    if (response.status == 200 && response.data == 1) {
                         toast.success("Message Send Successfully");
                         sendBtn.innerHTML = "Send";
                         contactForm.reset();
                    }
                    else {
                         toast.error("error");
                         sendBtn.innerHTML = "Send";
                    }
               })
                    .catch(function (error) {
                         toast.error(error);
                         sendBtn.innerHTML = "Send";
                    });
          }


          //event.preventDefault(); একটি মেথড, যা একটি ইভেন্টের ডিফল্ট আচরণ (default behavior) বন্ধ করার জন্য ব্যবহৃত হয়।
          //যদি একটি ফর্মের submit ইভেন্টে event.preventDefault(); ব্যবহার করা হয়, তাহলে ফর্মটি স্বাভাবিকভাবে রিফ্রেশ বা সাবমিট হবে না।
          // ডিফল্ট আচরণ হিসেবে পেজ রিলোড বা রিডিরেক্ট হয়
          //পেজ রিলোড বন্ধ করার জন্য সাধারণত event.preventDefault(); ব্যবহার করা হয়।
          //ফর্ম সাবমিশন বন্ধ করে API কল বা AJAX কল করার সুযোগ দেয়।, যাতে আমরা AJAX বা API এর মাধ্যমে ডেটা পাঠাতে পারি বা অন্য কাস্টম কাজ 
          //করতে পারি।
          event.preventDefault();

     }


     render() {
          return (
               <Fragment>
                    <Container>
                         <Row className="p-2">
                              <Col className="shadow-sm bg-white mt-2" md={12} lg={12} sm={12} xs={12}>

                                   <Row className="text-center">
                                        <Col className="d-flex justify-content-center" md={6} lg={6} sm={12} xs={12}>
                                             <Form id="contactForm" onSubmit={this.onFormSubmit} className="onboardForm">
                                                  <h4 className="section-title-login">CONTACT WITH US </h4>
                                                  <h6 className="section-sub-title">Please Contact With Us </h6>

                                                  <input onChange={this.nameOnChange} className="form-control m-2" type="text" placeholder="Enter Your Name" />

                                                  <input onChange={this.emailOnChange} className="form-control m-2" type="email" placeholder="Enter Email" />

                                                  <Form.Control onChange={this.messageOnChange} className="form-control m-2" as="textarea" rows={3} placeholder="Message" />

                                                  <Button id="sendBtn" type="submit" className="btn btn-block m-2 site-btn-login"> Send </Button>

                                             </Form>


                                        </Col>

                                        <Col className="p-0 Desktop m-0" md={6} lg={6} sm={6} xs={6}>
                                             <br></br><br></br>
                                             <p className="section-title-contact">
                                                  1635 Franklin Street Montgomery, Near Sherwood Mall. AL 36104
                                                  Email: Support@easylearningbd.com
                                             </p>
                                             {/*                                              
                                             <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d162771.1102477064!2d-74.10054944459704!3d40.70681480276415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1627241390779!5m2!1sen!2sbd" width="550" height="450" styles="border:0;" allowfullscreen="" loading="lazy"></iframe> */}
                                             <iframe
                                                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3648.9035158623355!2d90.42890731498233!3d23.71152548460552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b68979f9b2d1%3A0x46f63b6f1f38ad97!2sJatrabari%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1627241390779!5m2!1sen!2sbd"
                                                  width="550"
                                                  height="450"
                                                  style={{ border: '0' }}
                                                  allowFullScreen
                                                  loading="lazy">
                                             </iframe>









                                        </Col>
                                   </Row>






                              </Col>
                         </Row>
                    </Container>
                    <ToastContainer />
               </Fragment>
          )
     }
}

export default Contact
